export const formatCurrency = (amount, opts = {}) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'EUR', ...opts }).format(amount || 0);

// Compact currency for tight axis ticks: €2.3k, €-1.2k, €950, €0.
// Keeps labels narrow so they never truncate on a fixed-width axis gutter.
export const formatCurrencyCompact = (amount) => {
  const n = amount || 0;
  const abs = Math.abs(n);
  const sign = n < 0 ? '-' : '';
  if (abs >= 1000) {
    const k = abs / 1000;
    // one decimal below 10k (€2.3k), none above (€12k)
    const str = k >= 10 ? Math.round(k).toString() : (Math.round(k * 10) / 10).toString();
    return `${sign}€${str}k`;
  }
  return `${sign}€${Math.round(abs)}`;
};

export const formatHours = (hours) => {
  if (hours == null) return '—';
  if (hours < 1) return `${Math.round(hours * 60)}m`;
  return `${hours.toFixed(1)}h`;
};
